import PropTypes from 'prop-types';
import React from 'react';
import {
  Box,
  Slide,
  Stack,
  Button,
  TextField,
  Typography,
  Autocomplete,
  Divider,
  Switch,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel
} from '@mui/material';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import * as myLayananService from '../../../services/mylayanan';
import * as kategoriLayananService from '../../../services/kategorilayanan';
import RekomendasiCTA from '../../RekomendasiCTA';
import findIndex from '../../../utils/indexFinder';
import RequestsPackages from './RequestsPackages';
import * as tokenServices from '../../../services/token';

RequestsSubDomain.propTypes = {
  user: PropTypes.object.isRequired,
  setMenu: PropTypes.func.isRequired,
  rekomendasis: PropTypes.any.isRequired
};

export default function RequestsSubDomain({ user, setMenu, rekomendasis }) {
  const [subdomain, setSubdomain] = React.useState('');
  const [hosting, setHosting] = React.useState({});
  const [isHostingTokenValidated, setIsHostingTokenValidated] = React.useState(false);
  const [checkResult, setCheckResult] = React.useState({ is_registered: true });
  const navigate = useNavigate();
  const [rekomendasi, setRekomendasi] = React.useState('');
  const [packages, setPackages] = React.useState([]);
  const [tipePermohonan, setTipePermohonan] = React.useState('new_subdomain_hosting');
  const [token, setToken] = React.useState('');

  const isValidURL = (str) => {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  };

  const checkAvailability = async () => {
    setCheckResult({ is_registered: true });

    const isValid = isValidURL(subdomain);
    if (!isValid) return toast.error('Maaf, URL yang Anda masukkan tidak valid');

    let splitText = '';
    splitText = subdomain.replace(/ /g, '').split('.');

    if (splitText.length > 4) return toast.error('Maaf, subdomain tidak boleh lebih dari 1 level');

    if (splitText[1] !== 'jogjaprov')
      return toast.error('Maaf, harap gunakan top level domain "jogjaprov.go.id"');
    if (splitText[2] !== 'go')
      return toast.error('Maaf, harap gunakan top level domain "jogjaprov.go.id"');
    if (splitText[3] !== 'id')
      return toast.error('Maaf, harap gunakan top level domain "jogjaprov.go.id"');
    if (splitText[0].length < 3) return toast.error('Maaf, minimal panjang subdomain 3 karakter');

    try {
      const result = await myLayananService.subdomaincheck({ subdomain });

      if (result.is_registered)
        return toast.error(
          `Maaf, subdomain ${result.name} sudah digunakan atau didaftarkan, silakan coba subdomain lainnya`
        );

      toast.success(`Subdomain ${result.name} tersedia!`);
      setCheckResult(result);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const theme = useTheme();

  const createPermohonan = async () => {
    if (!user?.attributes?.id_instansi) return toast.error('ID Instansi tidak ditemukan');
    if (!user?.attributes?.id) return toast.error('ID User tidak ditemukan');
    if (!rekomendasi?.id) return toast.error('ID rekomendasi tidak ditemukan');

    const currentRekomendasi = rekomendasis[findIndex(rekomendasis, rekomendasi?.id, 'id')];

    if (tipePermohonan === 'new_subdomain_hosting') {
      if (currentRekomendasi?.meta?.attributes?.status !== 'approved')
        return toast.error(
          `Maaf, permohonan rekomendasi ${currentRekomendasi?.meta?.attributes?.name} belum disetujui`
        );
    }

    try {
      const body = {
        data: {
          type: 'subdomain',
          id: '1',
          attributes: {
            subdomain,
            hosting,
            id_kategori_layanan: 'subdomain',
            id_instansi: user?.attributes?.id_instansi,
            id_rekomendasi: rekomendasi.id,
            requestor: user?.attributes?.id,
            status: 'draft',
            id_jenis_permohonan: 'subdomain'
          },
          meta: {
            subdomain,
            hosting,
            tipe_permohonan: tipePermohonan
          }
        }
      };

      const result = await myLayananService.addLayanan(body);

      if (result) {
        try {
          if (token) {
            const tokenBody = {
              id: token,
              used_by: user?.attributes?.id
            };
            const tokenResult = await tokenServices.updateToken(tokenBody);

            if (tokenResult) {
              toast.success('Draft Permohonan berhasil dibuat');
              navigate(
                `/dashboard/services?page=1&size=${process.env.REACT_APP_PAGE_SIZE}&createdID=${result?.data?.id}&alert=1`,
                {
                  replace: true
                }
              );
            }
          } else {
            toast.success('Draft Permohonan berhasil dibuat');
            navigate(
              `/dashboard/services?page=1&size=${process.env.REACT_APP_PAGE_SIZE}&createdID=${result?.data?.id}&alert=1`,
              {
                replace: true
              }
            );
          }
        } catch (error) {
          toast.error(error.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Get Paket
  const getPackage = async () => {
    try {
      const result = await kategoriLayananService.getPaketLayanan({ id_layanan: 'subdomain' });

      setPackages(result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getPackage();
  }, []);

  React.useEffect(() => {
    if (checkResult.is_registered) setSubdomain('');
  }, [checkResult.is_registered]);

  React.useEffect(() => {
    if (tipePermohonan === 'archive') {
      setIsHostingTokenValidated(true);
    } else {
      setIsHostingTokenValidated(false);
    }
  }, [tipePermohonan]);

  const choosePackage = async (item) => {
    if (!_.isEmpty(item)) {
      setHosting({ value: item.attributes.name, id: item.id, meta: item.meta });
    } else {
      setHosting({});
    }
  };

  return (
    <>
      <Slide direction="left" in="true" mountOnEnter unmountOnExit>
        <Box sx={{ flexDirection: 'column' }}>
          <Stack
            spacing={3}
            direction="column"
            divider={<Divider orientation="horizontal" flexItem />}
          >
            <Box>
              <FormControl>
                <FormLabel id="permohonan-label">Jenis Permohonan</FormLabel>
                <RadioGroup
                  aria-labelledby="permohonan-aria-label"
                  defaultValue={tipePermohonan}
                  name="permohonan-group"
                  onChange={(e) => setTipePermohonan(e.target.value)}
                >
                  <FormControlLabel
                    value="new_subdomain_hosting"
                    control={<Radio />}
                    label="Permohonan subdomain & hosting baru"
                  />
                  {/* <FormControlLabel
                    value="new_subdomain"
                    control={<Radio />}
                    label="Permohonan subdomain baru"
                  />
                  <FormControlLabel
                    value="new_hosting"
                    control={<Radio />}
                    label="Permohonan hosting baru"
                  /> */}
                  <FormControlLabel
                    value="archive"
                    control={<Radio />}
                    label="Pendataan aplikasi lama/existing"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            {['new_subdomain', 'archive', 'new_subdomain_hosting'].includes(tipePermohonan) && (
              <Stack direction="column" spacing={1}>
                <Stack spacing={2} direction="row" alignItems="center">
                  <Box sx={{ flex: 4 }}>
                    <TextField
                      disabled={!checkResult.is_registered}
                      type="url"
                      value={subdomain}
                      onChange={(e) => setSubdomain(e.target.value.toLowerCase())}
                      size="small"
                      label="Masukkan subdomain ..."
                      fullWidth
                    />
                  </Box>
                  <Box sx={{ flex: 8 }}>
                    {checkResult.is_registered ? (
                      <Button variant="contained" onClick={checkAvailability}>
                        CEK DOMAIN
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="info"
                        onClick={() => setCheckResult({ ...checkResult, is_registered: true })}
                      >
                        CEK DOMAIN LAIN?
                      </Button>
                    )}
                  </Box>
                </Stack>
                <Box>
                  <Typography variant="body2" style={{ fontStyle: 'italic' }}>
                    Dapat dikosongkan jika hanya membutuhkan hosting
                  </Typography>
                </Box>
                <Box>
                  {!checkResult.is_registered && (
                    <Stack direction="column" spacing={1}>
                      <Typography sx={{ color: theme.palette.primary.main }} variant="body2">
                        Subdomain <b>{checkResult.name}</b> tersedia.
                      </Typography>
                    </Stack>
                  )}
                </Box>
              </Stack>
            )}

            {(!checkResult.is_registered ||
              ['archive', 'new_hosting', 'new_subdomain_hosting'].includes(tipePermohonan)) && (
              <Box>
                <RequestsPackages
                  user={user}
                  item={packages}
                  handleClick={choosePackage}
                  tipePermohonan={tipePermohonan}
                  isHostingTokenValidated={isHostingTokenValidated}
                  setIsHostingTokenValidated={setIsHostingTokenValidated}
                  token={token}
                  setToken={setToken}
                />
                <Divider />
                {(!hosting?.meta?.is_token_required || isHostingTokenValidated) && (
                  <Stack direction="column" spacing={1} mt={2}>
                    <Box>
                      <Autocomplete
                        disablePortal
                        id="combo-box-rekomendasi"
                        options={rekomendasis}
                        value={rekomendasi}
                        onChange={(event, newValue) => {
                          setRekomendasi(newValue);
                        }}
                        sx={{ width: 400 }}
                        renderInput={(params) => (
                          <TextField size="small" {...params} label="Nomor Rekomendasi" />
                        )}
                      />
                    </Box>
                    <RekomendasiCTA setMenu={setMenu} />

                    <Divider />

                    <Stack direction="column" spacing={2}>
                      <Box>
                        <Typography variant="h5">Preview permohonan</Typography>
                        <Typography variant="body2">
                          Subdomain: {subdomain && !checkResult.is_registered ? subdomain : '-'}
                        </Typography>
                        <Typography variant="body2">Hosting: {hosting.value || '-'}</Typography>
                        <Typography variant="body2">
                          Jenis Permohonan:{' '}
                          {tipePermohonan === 'archive'
                            ? 'Pendataan aplikasi lama/existing'
                            : 'Permohonan subdomain & hosting baru'}
                        </Typography>
                      </Box>
                      <Box>
                        <Button
                          onClick={() => createPermohonan()}
                          disabled={
                            (_.isEmpty(hosting) && checkResult.is_registered) || !rekomendasi
                          }
                          variant="contained"
                        >
                          BUAT PERMOHONAN
                        </Button>
                      </Box>
                    </Stack>
                  </Stack>
                )}
              </Box>
            )}
          </Stack>
        </Box>
      </Slide>
    </>
  );
}
